// <!-- GRACE:MODULE_START name="ui_auth" -->
// <!-- GRACE:DEPENDENCY target="ui_auth" -->
// <!-- GRACE:DEPENDENCY target="ui_config" -->
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CURRENT_CONFIG } from '../../config/environments';

// <!-- GRACE:CONTRACT function="ApprovalPage" -->
export default function ApprovalPage() {
  const { token } = useParams<{ token: string }>();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Токен подтверждения не указан');
      return;
    }

    const baseUrl = process.env.REACT_APP_API_BASE_URL || CURRENT_CONFIG.API_BASE_URL;
    fetch(`${baseUrl}/api/auth/approve/${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (res.ok) {
          setStatus('success');
          setMessage(data.message);
        } else {
          setStatus('error');
          setMessage(data.detail || 'Ошибка подтверждения');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Не удалось связаться с сервером');
      });
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md rounded-2xl border bg-white p-8 shadow-sm text-center">
        {status === 'loading' && <p className="text-sm text-gray-500">Подтверждение...</p>}

        {status === 'success' && (
          <>
            <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-green-100 text-green-600 text-xl">
              &#10003;
            </div>
            <h1 className="text-xl font-semibold mb-2">Успешно</h1>
            <p className="text-sm text-gray-600 mb-6">{message}</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-full bg-red-100 text-red-600 text-xl">
              &#10007;
            </div>
            <h1 className="text-xl font-semibold mb-2">Ошибка</h1>
            <p className="text-sm text-gray-600 mb-6">{message}</p>
          </>
        )}

        <Link
          to="/login"
          className="inline-block rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
        >
          Перейти к входу
        </Link>
      </div>
    </div>
  );
}
// <!-- GRACE:MODULE_END name="ui_auth" -->
